<!-- @file 地址卡片 -->
<template>
  <div :class="['plv-iar-address-card', { 'plv-iar-address-card--selected': checked }]" @click="$emit('click')">
    <div class="plv-iar-address-card-main">
      <div class="plv-iar-address-card-name">{{ dataSource.name }} {{ dataSource.mobile | formatMobileNumber(true) }}</div>
      <div class="plv-iar-address-card-address">{{ formatedAreaStr }}{{ dataSource.address }}</div>
    </div>
    <div class="plv-iar-address-card-footer">
      <button class="plv-iar-address-card-action" @click.stop="$emit('delete')">{{ iarTrans('address.delete') }}</button>
      <button class="plv-iar-address-card-action" @click.stop="$emit('edit')">{{ iarTrans('address.edit') }}</button>
    </div>
  </div>
</template>

<script>
import basicMixin from '../../assets/mixins/basic';
import { formatMobileNumber } from '../../assets/utils/utils';

export default {
  mixins: [basicMixin],
  props: {
    dataSource: {
      type: Object,
      default: () => ({})
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /** 格式化地区字符串 */
    formatedAreaStr() {
      if (!this.dataSource) return '';
      return this.dataSource.area?.split('/').join('');
    }
  },
  filters: {
    formatMobileNumber
  }
};
</script>

<style lang="scss">
.plv-iar-address-card {
  padding: 0 16px;
  border-radius: 8px;
  font-size: 14px;
  background: #fff;

  + .plv-iar-address-card {
    margin-top: 8px;
  }

  &.plv-iar-address-card--selected {
    .plv-iar-address-card-main {
      &::after {
        display: block;
      }
    }
  }

  .plv-iar-address-card-main {
    position: relative;
    padding: 12px 54px 12px 0;
    border-bottom: 1px solid #E6E6E6;

    &::after {
      position: absolute;
      display: none;
      content: '';
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      width: 14px;
      height: 10px;
      background: url('./images/check-outlined.svg') no-repeat;
    }
  }

  .plv-iar-address-card-name {
    margin-bottom: 4px;
    color: rgba(0, 0, 0, 0.8);
  }

  .plv-iar-address-card-address {
    color: rgba(0, 0, 0, 0.4);
  }

  .plv-iar-address-card-footer {
    // padding: 10px 0;
    text-align: right;
  }

  .plv-iar-address-card-action {
    height: 40px;
    line-height: 40px;
    padding: 0;
    color: rgba(0, 0, 0, 0.4);
    border: none;
    outline: none;
    background: transparent;

    +.plv-iar-address-card-action {
      margin-left: 20px;
    }
  }
}
</style>
